<template>
  <t-form labelWidth="100px">
    <t-form-item label="字体颜色">
      <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.textColor" size="small"/>
    </t-form-item>
    <t-form-item label="字体">
      <t-select v-model="attribute.fontFamily" size="small">
        <t-option v-for="item in textFamilyList" :key="item.value" :label="item.label" :value="item.value"/>
      </t-select>
    </t-form-item>
    <t-form-item label="加粗">
      <t-radio-group v-model="attribute.fontWeight" size="small">
        <t-radio-button value="lighter">更细</t-radio-button>
        <t-radio-button value="normal">正常</t-radio-button>
        <t-radio-button value="bold">加粗</t-radio-button>
      </t-radio-group>
    </t-form-item>
    <t-form-item label="字体大小">
      <t-input-number :min="10" :max="250" v-model="attribute.fontSize"  size="small" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="格式化">
<!--      <t-input v-model="attribute.format" size="small"/>-->
      <t-select v-model="attribute.format" size="small">
        <t-option label="yyyy-MM-dd" value="yyyy-MM-dd"/>
        <t-option label="yyyy年MM月dd日" value="yyyy年MM月dd日"/>
        <t-option label="yyyy/MM/dd" value="yyyy/MM/dd"/>
        <t-option label="yyyy.MM.dd" value="yyyy.MM.dd"/>
      </t-select>
    </t-form-item>
    <t-form-item label="显示日期">
      <t-switch v-model="attribute.showDate" :label="['开', '关']" size="small"/>
    </t-form-item>
    <t-form-item label="显示时间">
      <t-switch v-model="attribute.showTime" :label="['开', '关']" size="small"/>
    </t-form-item>
    <t-form-item label="显示星期">
      <t-switch v-model="attribute.showWeek" :label="['开', '关']" size="small"/>
    </t-form-item>
    <t-form-item label="时间格式">
      <t-radio-group v-model="attribute.hourType" size="small">
        <t-radio-button :value="1">12小时</t-radio-button>
        <t-radio-button :value="2">24小时</t-radio-button>
      </t-radio-group>
    </t-form-item>
    <t-form-item label="对齐方式">
      <t-radio-group v-model="attribute.textAlign" size="small">
        <t-radio-button value="left">左对齐</t-radio-button>
        <t-radio-button value="center">居中</t-radio-button>
        <t-radio-button value="right">右对齐</t-radio-button>
      </t-radio-group>
    </t-form-item>
    <t-form-item label="数据源" :help="'指定时间时取数据源中设置的时间戳'">
      <t-radio-group v-model="attribute.dataType" size="small">
        <t-radio-button :value="0">当前时间</t-radio-button>
        <t-radio-button :value="1">指定时间</t-radio-button>
      </t-radio-group>
    </t-form-item>
  </t-form>
</template>

<script>
export default {
  name: "cpt-datetime-option",
  props: {attribute: Object},
  data(){
    return {
      textFamilyList:[]
    }
  },
  created() {
    this.textFamilyList = require('@/assets/font/font-list')
  },
}
</script>

<style scoped>

</style>
